// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

//ローディング
// document.addEventListener('DOMContentLoaded', function () {
//   const el = document.querySelector('.js-clip');
//   if (!el) return;

//   requestAnimationFrame(() => {
//     el.classList.add('is-show');
//   });
// });


// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });

// アコーディオンの起動 // Activate the accordion
jQuery(function($) {
	if ( $('dl.accordion dt').length > 0 ) {
		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

jQuery(function($) {
  $('.js-open').click(function () {
    $("body").addClass("no_scroll");
    var id = $(this).data('id'); // 何番目のキャプション（モーダルウィンドウ）か認識
    $('#overlay, .modal-window[data-id="modal' + id + '"]').fadeIn();
  });
  // オーバーレイクリックでもモーダルを閉じるように
  $('.js-close , #overlay').click(function () {
    $("body").removeClass("no_scroll"); // 背景固定させるクラス削除
    $('#overlay, .modal-window').fadeOut();
  });
});



jQuery(function($) {
	$(window).on('scroll', function() {
		if ($(this).scrollTop() > 200) {
			$('.p-fixLine .c-btn').addClass('is-show');
		} else {
			$('.p-fixLine .c-btn').removeClass('is-show');
		}
	});
});

$(function () {

  // TAB CLICK
  $(".tab-btn").on("click", function () {
    const tabId = $(this).data("tab");
    const $currentTab = $(".tab-content.active");

    $currentTab.find(".recruit__toggle").removeClass("expand");
    $currentTab.removeClass("is-open");
    $currentTab.find(".js-more").hide();
    $currentTab.find(".js-toggle").html('詳しく見る <span>+</span>');

    $(".tab-btn").removeClass("active");
    $(".tab-content").removeClass("active");

    $(this).addClass("active");
    $("#" + tabId).addClass("active");
  });


  // TOGGLE
  $(".js-toggle").on("click", function () {
    const $btn = $(this);
    const $toggleWrap = $btn.parent();
    const $tab = $btn.closest(".tab-content");
    const $more = $tab.find(".js-more");

    $toggleWrap.toggleClass("expand");

    if ($toggleWrap.hasClass("expand")) {
      $tab.addClass("is-open");
      $more.stop(true, true).slideDown(200);
      $btn.html('閉じる <span>-</span>');
    } else {
      $tab.removeClass("is-open");
      $more.stop(true, true).slideUp(200);
      $btn.html('詳しく見る <span>+</span>');
    }
  });

});